"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Custom = exports.Basic = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _Table = _interopRequireDefault(require("@material-ui/core/Table"));

var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));

var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));

var _TableContainer = _interopRequireDefault(require("@material-ui/core/TableContainer"));

var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));

var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var css = _interopRequireWildcard(require("./Table.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Basic = function Basic(_ref) {
  var title = _ref.title,
      caption = _ref.caption,
      data = _ref.data,
      columns = _ref.columns,
      _ref$stickyHeader = _ref.stickyHeader,
      stickyHeader = _ref$stickyHeader === void 0 ? false : _ref$stickyHeader,
      props = _objectWithoutProperties(_ref, ["title", "caption", "data", "columns", "stickyHeader"]);

  return (0, _jsxRuntime.jsxs)(_TableContainer["default"], _objectSpread(_objectSpread({
    component: _Paper["default"],
    elevation: 0
  }, props), {}, {
    children: [title && (0, _jsxRuntime.jsx)("h2", {
      children: title
    }), caption && (0, _jsxRuntime.jsx)("p", {
      children: caption
    }), (0, _jsxRuntime.jsxs)(_Table["default"], {
      stickyHeader: stickyHeader,
      children: [(0, _jsxRuntime.jsx)(_TableHead["default"], {
        children: (0, _jsxRuntime.jsx)(_TableRow["default"], {
          css: css.headerRow,
          children: columns.map(function (heading) {
            return (0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: heading
            }, heading);
          })
        })
      }), (0, _jsxRuntime.jsx)(_TableBody["default"], {
        css: css.body,
        children: data.map(function (row, i) {
          return (// eslint-disable-next-line react/no-array-index-key
            (0, _jsxRuntime.jsx)(_TableRow["default"], {
              children: Object.entries(row).map(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    key = _ref3[0],
                    value = _ref3[1];

                return (0, _jsxRuntime.jsx)(_TableCell["default"], {
                  scope: "row",
                  children: value
                }, key);
              })
            }, i + 1)
          );
        })
      })]
    })]
  }));
};

exports.Basic = Basic;

var Custom = function Custom(_ref4) {
  var title = _ref4.title,
      caption = _ref4.caption,
      columns = _ref4.columns,
      children = _ref4.children,
      _ref4$stickyHeader = _ref4.stickyHeader,
      stickyHeader = _ref4$stickyHeader === void 0 ? false : _ref4$stickyHeader,
      props = _objectWithoutProperties(_ref4, ["title", "caption", "columns", "children", "stickyHeader"]);

  return (0, _jsxRuntime.jsxs)(_TableContainer["default"], _objectSpread(_objectSpread({
    component: _Paper["default"],
    elevation: 0
  }, props), {}, {
    children: [title && (0, _jsxRuntime.jsx)("h2", {
      children: title
    }), caption && (0, _jsxRuntime.jsx)("p", {
      children: caption
    }), (0, _jsxRuntime.jsxs)(_Table["default"], {
      stickyHeader: stickyHeader,
      children: [(0, _jsxRuntime.jsx)(_TableHead["default"], {
        children: (0, _jsxRuntime.jsx)(_TableRow["default"], {
          css: css.headerRow,
          children: columns.map(function (heading) {
            return (0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: heading
            }, heading);
          })
        })
      }), (0, _jsxRuntime.jsx)(_TableBody["default"], {
        css: css.body,
        children: children
      })]
    })]
  }));
};

exports.Custom = Custom;